<template>
    <span class="inline-flex items-center gap-2 font-bold tracking-tight">
        <svg
            :class="markClass"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
        >
            <rect
                x="2"
                y="2"
                width="28"
                height="28"
                rx="7"
                class="fill-indigo-600"
            />
            <path
                d="M9 20.5c1.2 1.6 3 2.5 5.2 2.5 2.9 0 4.8-1.5 4.8-3.7 0-4.6-9.4-2.3-9.4-8 0-2.4 2-4.3 5-4.3 2 0 3.7.8 4.8 2.3"
                stroke="#fff"
                stroke-width="2.4"
                stroke-linecap="round"
            />
        </svg>
        <span v-if="!markOnly">Sorex</span>
    </span>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    markClass?: string;
    markOnly?: boolean;
}>(), {
    markClass: "h-7 w-7",
    markOnly: false,
});
</script>
